/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastchanged1Inputs */

const de__field_lastchanged1 = /** @type {(inputs: _Field_Lastchanged1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Änderung`)
};

/**

* @param {_Field_Lastchanged1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastchanged1 = /** @type {((inputs?: _Field_Lastchanged1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastchanged1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lastchanged1(inputs)
});
export { _field_lastchanged1 as "_field_lastChanged" }